module.exports = __webpack_public_path__ + "img/towers.6347c41e.webp";